const ADD_CARD = 'CARD/ADD_CARD'
const UPDATE_CARD = 'CARD/UPDATE_CARD'
const DELETE_CARD = 'CARD/DELETE_CARD'
// TODO: add more action types if necessary

export {
  ADD_CARD,
  UPDATE_CARD,
  DELETE_CARD,
  // TODO: export action types added later
}
